import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AuthBtns } from '../AuthBtns';
import { links } from './data';
import * as Styled from './HeaderMenu.styles';

const HeaderMenu = ({ isOpen, onNavLinkClick }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const containerVariants = {
    open: {
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.1,
      },
    },
    closed: {
      transition: {
        staggerChildren: 0,
      },
    },
  };

  const linkVariants = {
    open: (isLinkActive) => ({
      y: 0,
      rotate: 0,
      opacity: isLinkActive ? 1 : 0.5,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
      },
    }),
    closed: {
      y: 40,
      rotate: -5,
      opacity: 0,
      transition: {
        duration: 0,
        type: 'tween',
      },
    },
  };

  return (
    <Styled.Menu isOpen={isOpen}>
      <Styled.Container>
        <Styled.Links
          initial="closed"
          animate={isOpen ? 'open' : 'closed'}
          variants={containerVariants}
        >
          <Styled.Buttons>
            <AuthBtns />
          </Styled.Buttons>

          {links.map((link) => {
            const isLinkActive = !link.sectionId && pathname === link.href;

            return (
              <Styled.Link
                key={link.labelKey}
                to={link.href}
                variants={linkVariants}
                isLinkActive={isLinkActive}
                custom={isLinkActive}
                whileHover={{ opacity: 0.7 }}
                transition={{ duration: 0.3 }}
                onClick={(event) => {
                  if (link.sectionId) {
                    event.preventDefault();
                  }
                  onNavLinkClick?.(event, link);
                }}
              >
                {t(link.labelKey)}
              </Styled.Link>
            );
          })}
        </Styled.Links>

        <Styled.Logo variant="logo" />
      </Styled.Container>
    </Styled.Menu>
  );
};

export default HeaderMenu;
